module.exports = __webpack_public_path__ + "media/img/pages/profile/axpo ger 7-bdb0ccae5957574e465f7c8015be6e1d.jpg";